import { styled } from "../../../styles";

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  padding: "24px 32px",
  gap: "20px",
  maxWidth: "1600px",
  margin: "0 auto",
  width: "100%",
});

export const HeaderRow = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "24px",
  flexWrap: "wrap",
});

export const HeaderTextBlock = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const Title = styled("h1", {
  fontFamily: "$nunito",
  fontSize: "28px",
  fontWeight: 700,
  color: "$black",
  margin: 0,
});

export const Subtitle = styled("p", {
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$gray-80",
  margin: 0,
});

export const HeaderFilters = styled("div", {
  display: "flex",
  gap: "12px",
  alignItems: "center",
});

export const PowerBiButton = styled("a", {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "40px",
  padding: "0 24px",
  borderRadius: "20px",
  backgroundColor: "$charcoal",
  color: "$white",
  fontFamily: "$openSans",
  fontSize: "15px",
  fontWeight: 600,
  textDecoration: "none",
  whiteSpace: "nowrap",
  cursor: "pointer",
  transition: "opacity 0.2s ease",

  "&:hover": {
    opacity: 0.85,
  },
});

export const ConversationalReportingButton = styled("a", {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  height: "40px",
  padding: "0 24px",
  borderRadius: "20px",
  backgroundColor: "$gray-40",
  color: "$charcoal",
  fontFamily: "$openSans",
  fontSize: "15px",
  fontWeight: 600,
  textDecoration: "none",
  whiteSpace: "nowrap",
  cursor: "pointer",
  transition: "opacity 0.2s ease",

  "&:hover": {
    opacity: 0.85,
  },
});

export const KpiRow = styled("div", {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "16px",

  "@lg": {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
});

export const KpiCardBase = styled("div", {
  backgroundColor: "$white",
  borderRadius: "12px",
  border: "1px solid $gray-30",
  padding: "20px 24px",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  position: "relative",
  overflow: "hidden",

  "&::before": {
    content: "''",
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: "4px",
  },

  variants: {
    accent: {
      primary: { "&::before": { backgroundColor: "$primary" } },
      secondary: { "&::before": { backgroundColor: "$secondary" } },
      success: { "&::before": { backgroundColor: "$success" } },
      warning: { "&::before": { backgroundColor: "$warning" } },
    },
  },
});

export const KpiLabel = styled("span", {
  fontFamily: "$openSans",
  fontSize: "12px",
  fontWeight: 500,
  color: "$gray-90",
  letterSpacing: "0.3px",
  textTransform: "uppercase",
});

export const KpiValue = styled("span", {
  fontFamily: "$nunito",
  fontSize: "28px",
  fontWeight: 700,
  color: "$black",
  lineHeight: 1.1,
});

export const KpiDelta = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  gap: "4px",
  fontFamily: "$openSans",
  fontSize: "12px",
  fontWeight: 600,

  variants: {
    direction: {
      up: { color: "$success" },
      down: { color: "$error" },
      flat: { color: "$gray-80" },
    },
  },
});

export const DashboardGrid = styled("div", {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "16px",

  "@lg": {
    gridTemplateColumns: "1fr",
  },
});

export const ChartCard = styled("div", {
  backgroundColor: "$white",
  borderRadius: "12px",
  border: "1px solid $gray-30",
  padding: "20px 24px",
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  minHeight: "320px",
});

export const ChartHeader = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
});

export const ChartTitle = styled("h3", {
  fontFamily: "$nunito",
  fontSize: "16px",
  fontWeight: 700,
  color: "$charcoal",
  margin: 0,
});

export const ChartSubtitle = styled("span", {
  fontFamily: "$openSans",
  fontSize: "12px",
  color: "$gray-80",
});

export const ChartBody = styled("div", {
  flex: 1,
  minHeight: "260px",
  width: "100%",
});

export const AccessDeniedCard = styled("div", {
  backgroundColor: "$white",
  borderRadius: "12px",
  border: "1px solid $gray-30",
  padding: "48px 32px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "12px",
  textAlign: "center",
});

export const AccessDeniedTitle = styled("h2", {
  fontFamily: "$nunito",
  fontSize: "20px",
  fontWeight: 700,
  color: "$charcoal",
  margin: 0,
});

export const AccessDeniedBody = styled("p", {
  fontFamily: "$openSans",
  fontSize: "14px",
  color: "$gray-80",
  margin: 0,
  maxWidth: "520px",
});
